import { Button, Divider, PageTitle } from "../../../../../../../components";

const BillingDetail = ({ onContinue }) => {
  const SubscriptionCard = ({
    title,
    planLabel = "Professional Plan",
    users,
    showUsers = true,
    showViewDetails = true,
    subscriptionTerm,
    nextBillingDate,
    addons = [],
  }) => (
   <div className="flex items-start border border-gray-300 rounded-md p-4 pt-10 shadow-md relative">

      <div className="absolute right-0 top-0 p-2 text-sm bg-primary-50 px-5">
        {planLabel}
      </div>

      <div className="flex flex-col gap-4 flex-grow">
        <div className="flex justify-between items-start">
         <div className="flex flex-row md:flex-col lg:flex-row gap-2 md:gap-1 lg:gap-3 items-start lg:items-center">
  <PageTitle title={title} tag="h6" />

  {showViewDetails && (
    <a className="text-primary-500 underline cursor-pointer text-sm whitespace-nowrap">
      View Plan Details
    </a>
  )}
</div>
        </div>

        {showUsers && (
          <div className="text-sm">
            <span className="font-medium text-primary-500 bg-primary-50 text-xs px-2 py-1 rounded-md">
              {users}
            </span>
          </div>
        )}

        <Divider />

        {subscriptionTerm && nextBillingDate && (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

              <div>
                <span className="block mb-3 text-neutrals-500">
                  ATS Subscription
                </span>
                <span className="block text-500 text-sm lg:text-md">
                  1 Month(s) Subscription
                </span>
              </div>

              <div>
                <span className="block mb-3 text-neutrals-500">
                  Subscription Term
                </span>
                <span className="block text-500  text-sm lg:text-md">
                  {subscriptionTerm}
                </span>
              </div>

              <div>
                <span className="block mb-3 text-neutrals-500">
                  Next Billing Date
                </span>
                <span className="block text-500 text-sm lg:text-md">
                  {nextBillingDate}
                </span>
              </div>
            </div>

            <Divider />
          </>
        )}

        <div>
          <div className="text-xs text-neutrals-500 mb-3">Addons</div>
          {addons.map((item, index) => (
            <div key={index} className="text-sm">
              {index + 1}. {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="p-5 flex-grow">
      <div className="flex justify-between items-center py-2 mb-2">
        <PageTitle title="Billing Details" tag="h6" />

        <Button title="Renew" variant="outlined" onClick={onContinue} />
      </div>

      <div className="flex flex-col gap-6">
        <SubscriptionCard
          title="Application Tracking System (ATS)"
          users="5/5 Users"
          subscriptionTerm="Aug 12, 2025 - Sep 11, 2025"
          nextBillingDate="Sep 12, 2025"
          addons={["ATS"]}
        />

        <SubscriptionCard
          title="Workforce"
          users="5/5 Users"
          subscriptionTerm="Aug 12, 2025 - Sep 11, 2025"
          nextBillingDate="Sep 12, 2025"
          addons={["ATS"]}
        />

        <SubscriptionCard
          title="Additional Services"
          showUsers={false}
          showViewDetails={false}
          addons={["Digital Templates - 50 Credit(s)"]}
        />
      </div>
    </div>
  );

  
};
export default BillingDetail